import Vue from 'vue';
import * as VueGoogleMaps from 'vue2-google-maps';

Vue.use(VueGoogleMaps, {
    load: {
        key: 'AIzaSyAngZTY39RyrrsQKMFaKdBvZ-nHFDSr9os',
        libraries: 'places'
    }
});
